<div style="text-align: center; min-width: 300px">
  <div mat-dialog-content>
    <lemon-dialog-header> Muokkaa asiakkaan Google Sheet -linkkiä </lemon-dialog-header>
    <form (ngSubmit)="tallenna()">
      <mat-form-field>
        <mat-label>Google Sheet -linkki</mat-label>
        <input matInput type="url" [formField]="lomake.sheetLink" />
      </mat-form-field>
    </form>
  </div>

  <div mat-dialog-actions style="padding-left: 0; padding-right: 0; gap: 0.25rem">
    <app-primary-button actionId="Muokkaa linkkiä: Peruuta ja sulje dialog" [focusRegionStart]="true" mat-dialog-close>Sulje</app-primary-button>
    <app-secondary-button (click)="tallenna()" actionId="Muokkaa linkkiä: Tallenna">Tallenna</app-secondary-button>
  </div>
</div>
